<template>
    <div
        class="l-ss-c-catalog-btn"
        :class="{
            'l-ss-c-catalog-btn-active': isOpened,
            'l-ss-c-catalog-btn-selected': isSelectedCategory
        }"
        @click="$emit('click', $event)">
        <span
            v-if="!isMobile"
            class="l-ss-c-catalog-btn-text"
            v-html="`${title}&nbsp;`"></span>

        <i
            v-if="!isSelectedCategory"
            v-html="iconArrowDown"
            class="l-ss-c-catalog-btn-arrow"></i>

        <delete-btn
            v-else
            @click="$emit('clear', $event)"/>

        <!--        <button-->
        <!--            v-else-->
        <!--            class="l-ss-c-catalog-btn-clear"-->
        <!--            @click="$emit('clear', $event)">-->
        <!--            <i v-html="deleteIcon"></i>-->
        <!--        </button>-->
    </div>
</template>

<script>
    import { computed } from '@vue/composition-api';

    // Import BurgerIcon from '@/core/components/burger-icon.vue';
    import iconArrowDown from '@/core/assets/images/icons/arrow-right.svg';
    import deleteIcon from '../../assets/images/icons/delete.svg';
    import DeleteBtn from '@/core/components/delete-btn';

    export default {
        components: {
            // BurgerIcon,
            DeleteBtn,
        },
        props: {
            isMobile: {
                type: Boolean,
            },
            isOpened: {
                type: Boolean,
            },
            selectedCategory: {
                type: Object,
            },
        },
        setup(props) {
            const isSelectedCategory = computed(() => !!props.selectedCategory?.id);

            const title = computed(() => {
                return props.selectedCategory.title;
            });

            return {
                iconArrowDown,
                deleteIcon,
                isSelectedCategory,
                title,
            };
        },
    };
</script>

<style scoped>

</style>
